import React from 'react';

import { PhoneIcon } from '@ergeon/icons/hero/micro';

export const MissedCallMessage: React.FC = () => (
  <div className="flex items-center gap-1">
    <PhoneIcon className="size-4" />
    <span>Missed call</span>
  </div>
);
